/* Busca por rotulo de time (Match Day).
 *
 * A busca da Shopify indexa o titulo REAL do produto, que nao tem rotulo de time.
 * Aqui o termo buscado vira um REDIRECT pra colecao correspondente. Quando o termo
 * nao casa com nada, a busca normal da Shopify roda como sempre.
 *
 * O MAPA NAO MORA AQUI: vem do mesmo servico externo dos rotulos (data-md-labels no
 * <html>), pra que nenhum termo de marca precise existir dentro do tema. Fica em cache
 * no navegador por 24h. Em /search e pedido na hora; nas outras paginas, so quando o
 * cliente encosta na busca. Servico fora do ar: a busca padrao da Shopify assume.
 */
(function () {
  "use strict";

  /* Palavras que a pessoa digita junto do time e que nao ajudam a identificar:
     "<termo> jersey", "<termo> shirt 26/27" e "<termo>" tem que cair no mesmo lugar. */
  var RUIDO = [
    "shirt", "shirts", "jersey", "jerseys", "kit", "kits", "camisa", "camisas",
    "football", "soccer", "fc", "cf", "club", "team", "home", "away", "third",
    "men", "mens", "women", "womens", "kid", "kids", "player", "fan", "retro", "new"
  ];

  function normalizar(s) {
    return (s || "")
      .toString()
      .toLowerCase()
      .normalize("NFD")
      .replace(/[̀-ͯ]/g, "")
      .replace(/[^a-z0-9\s]/g, " ")
      .replace(/\s+/g, " ")
      .replace(/^\s+|\s+$/g, "");
  }

  /* Indice termo -> colecao, montado uma vez a partir do mapa invertido. */
  var INDICE = null;
  function montarIndice() {
    if (INDICE) return INDICE;
    var bruto = window.__MD_SEARCH_MAP;
    if (!bruto) return null;
    INDICE = {};
    for (var colecao in bruto) {
      var termos = bruto[colecao];
      for (var i = 0; i < termos.length; i++) {
        var k = normalizar(termos[i]);
        if (k && !INDICE[k]) INDICE[k] = colecao;
      }
    }
    return INDICE;
  }

  /* Tenta, em ordem: termo inteiro -> termo sem as palavras de ruido -> cada pedaco de
     2 palavras -> cada palavra isolada. A primeira que casar ganha. */
  function resolver(termo) {
    var idx = montarIndice();
    if (!idx) return null;

    var t = normalizar(termo);
    if (!t) return null;
    if (idx[t]) return idx[t];

    var partes = t.split(" ");
    /* Fora do match exato, token puramente numerico e descartado: "<termo> shirt 26/27"
       vira "<termo> 26 27" e o par "26 27" casaria com a colecao de temporada em vez do time.
       Quem busca so "1986" continua atendido, porque o termo inteiro e testado antes disto. */
    var limpo = partes.filter(function (p) {
      return RUIDO.indexOf(p) === -1 && p.length > 1 && !/^[0-9]+$/.test(p);
    });

    if (limpo.length) {
      var semRuido = limpo.join(" ");
      if (idx[semRuido]) return idx[semRuido];

      /* pares consecutivos: pega "<termo composto>" dentro de "<termo composto> away kit" */
      for (var i = 0; i < limpo.length - 1; i++) {
        var par = limpo[i] + " " + limpo[i + 1];
        if (idx[par]) return idx[par];
      }
      /* palavra isolada, da mais longa pra mais curta (a mais especifica primeiro) */
      var sozinhas = limpo.slice().sort(function (a, b) { return b.length - a.length; });
      for (var j = 0; j < sozinhas.length; j++) {
        if (idx[sozinhas[j]]) return idx[sozinhas[j]];
      }
    }
    return null;
  }

  function irPara(colecao, termo) {
    var raiz = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
    if (raiz.charAt(raiz.length - 1) !== "/") raiz += "/";
    /* md_q preserva o que a pessoa digitou, util pra medir busca no analytics */
    window.location.replace(raiz + "collections/" + colecao + "?md_q=" + encodeURIComponent(termo));
  }

  /* ---- 1) Ja estamos em /search?q=... : redireciona antes de pintar "sem resultados" ---- */
  function tratarPaginaDeBusca() {
    if (!/\/search\b/.test(window.location.pathname)) return;
    var q = new URLSearchParams(window.location.search).get("q");
    if (!q) return;
    /* aqui vale esperar a rede: sem isso a pessoa ve "nenhum resultado" a toa */
    obterMapa().then(function (mapa) {
      if (!mapa) return;
      var destino = resolver(q);
      if (destino) irPara(destino, q);
    });
  }

  /* ---- 2) Submissao do formulario de busca em qualquer pagina ---- */
  function interceptarFormularios() {
    document.addEventListener(
      "submit",
      function (ev) {
        var form = ev.target;
        if (!form || !form.action || form.action.indexOf("/search") === -1) return;
        var campo = form.querySelector('input[name="q"]');
        if (!campo || !campo.value) return;
        /* so intercepta se o mapa ja estiver em maos; senao deixa a busca normal seguir */
        if (!window.__MD_SEARCH_MAP) return;
        var destino = resolver(campo.value);
        if (destino) {
          ev.preventDefault();
          irPara(destino, campo.value);
        }
      },
      true
    );
  }

  /* ---- 3) O mapa vem do servico externo, com cache de 24h no navegador ---- */
  var CACHE_KEY = "md_searchmap_v1";
  var TTL = 24 * 3600 * 1000;

  function doCache() {
    try {
      var cru = localStorage.getItem(CACHE_KEY);
      if (!cru) return null;
      var o = JSON.parse(cru);
      if (!o || !o.map || Date.now() - o.ts > TTL) return null;
      return o.map;
    } catch (e) { return null; }
  }

  function guardar(map) {
    try { localStorage.setItem(CACHE_KEY, JSON.stringify({ ts: Date.now(), map: map })); } catch (e) {}
  }

  /* Cache servido: confere em segundo plano se o mapa mudou, senao um time novo so
     entraria na busca 24h depois. O Worker responde 304 quando nada mudou, entao a
     conferencia custa alguns bytes em vez dos 152KB. A busca em curso usa o mapa que
     ja estava em maos; a proxima ja usa o novo. */
  function revalidar() {
    if (window.__mdMapaRevalidado) return;
    window.__mdMapaRevalidado = true;
    var base = document.documentElement.getAttribute("data-md-labels");
    if (!base || typeof fetch !== "function") return;
    fetch(base + "/search-map", { credentials: "omit", cache: "no-cache" })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        if (!j || !Object.keys(j).length) return;
        guardar(j);
        window.__MD_SEARCH_MAP = j;
      })
      .catch(function () {});
  }

  /* devolve promessa do mapa: cache -> rede. Falhou, resolve null e a busca da Shopify roda. */
  function obterMapa() {
    var local = doCache();
    if (local) { window.__MD_SEARCH_MAP = local; revalidar(); return Promise.resolve(local); }
    if (window.__mdMapaPromessa) return window.__mdMapaPromessa;

    var base = document.documentElement.getAttribute("data-md-labels");
    if (!base || typeof fetch !== "function") return Promise.resolve(null);

    window.__mdMapaPromessa = fetch(base + "/search-map", { credentials: "omit" })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        if (!j || !Object.keys(j).length) return null;
        guardar(j);
        window.__MD_SEARCH_MAP = j;
        return j;
      })
      .catch(function () { return null; });
    return window.__mdMapaPromessa;
  }

  /* fora de /search o mapa so e pedido quando o cliente encosta na busca */
  function carregarSobDemanda() { obterMapa(); }

  function armarGatilhos() {
    var eventos = ["focusin", "pointerdown", "keydown"];
    for (var i = 0; i < eventos.length; i++) {
      document.addEventListener(
        eventos[i],
        function (ev) {
          var alvo = ev.target;
          if (!alvo || !alvo.closest) return;
          if (alvo.closest('form[action*="/search"], [href*="/search"], input[name="q"], .header__icon--search, [class*="search"]')) {
            carregarSobDemanda();
          }
        },
        true
      );
    }
  }

  function iniciar() {
    tratarPaginaDeBusca();
    interceptarFormularios();
    armarGatilhos();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", iniciar);
  } else {
    iniciar();
  }
})();
